import { Card } from 'antd'
import React from 'react'
import ResetPasswordBtn from '../../Component/Button/ResetPasswordBtn';

const Setting = () => {
    return (
        <Card style={{ height: "100%", overflow: "auto" }}>
            <ResetPasswordBtn />
        </Card>
    )
}

export default Setting